import React, { useContext } from "react";
import pptpage from "../Faultanalysis_Coral/pptpage.pdf";
import AppContext from '../../../store/AppContext';
import DashboardMain_Coral from "../DashboardMain_Coral/DashboardMain_Coral";

function PPTPageFaultanalysis_Coral() {
  const app_ctx = useContext(AppContext);
  return (
    <>
      <DashboardMain_Coral>
        <iframe src={pptpage} style={{ marginTop: "7%" }} frameborder="0" height="500em" width="100%" sandbox></iframe>
      </DashboardMain_Coral>
    </>
  );
}

export default PPTPageFaultanalysis_Coral;